import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton, SecondaryIconButton } from '../../theme/index';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function createData(id, room, mount, service, total, checkIn, checkOut) {
  return { id, room, mount, service, total, checkIn, checkOut };
}

const rows = [
  createData('3', 'Junior Suite', 60, 30, 90, '07/06/2022', '07/10/2022'),
];


const DailyReportCash = () => {
  return (
    <>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Habitación</TableCell>
                    <TableCell>Dinero dejado</TableCell>
                    <TableCell>Servicio</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Hora de ingreso</TableCell>
                    <TableCell>Hora de salida</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {rows.map((row) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    <TableCell>{row.room}</TableCell>
                    <TableCell>{row.mount}</TableCell>
                    <TableCell>{row.service}</TableCell>
                    <TableCell>{row.total}</TableCell>
                    <TableCell>{row.checkIn}</TableCell>
                    <TableCell>{row.checkOut}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    </>
  )
}

export default DailyReportCash